// errText.mjs — the ONE ApiError → i18n-key mapper (SB-042). Pure: returns a
// KEY, never calls t(), so it is unit-testable without React.
//
// Before this module the same skeleton existed seven times (3 named copies in
// AdminAccounts/WorkHours/DocBrowser + 4 inline ternary chains) and each copy
// covered a slightly different subset — the drift was the bug surface.
//
// Contract:
//   errKey(e, spec) → i18n key
//   spec.byCode:   { API error code → key }     (checked first — most specific)
//   spec.byStatus: { HTTP status  → key }       (overrides the built-ins)
//   spec.fallback: key                          (required)
// Built-ins every surface shares: status 0 → common.error.network (fetch failed),
// 401 → common.error.session (signed out). Overridable via byStatus.
import { ApiError } from './client.mjs';

export function errKey(e, spec) {
  const { byCode = {}, byStatus = {}, fallback } = spec || {};
  if (e instanceof ApiError) {
    if (e.code && byCode[e.code]) return byCode[e.code];
    if (byStatus[e.status]) return byStatus[e.status];
    if (e.status === 0) return 'common.error.network';
    if (e.status === 401) return 'common.error.session';
  }
  return fallback;
}

// Batch 43 (language rule): backend RULE_VIOLATION messages are English-only
// ("R-05: minutes must be…"). The rule ID they are prefixed with is stable
// machine data — map it to an i18n key so the member sees their own language.
// Returns `rule.R-05`-style key when the message carries an ID, else null;
// the caller keeps the raw message as the last-resort fallback (unknown rules
// stay verbatim rather than vanishing).
export function ruleKey(e) {
  const msg = e instanceof ApiError ? e.message : null;
  const m = msg ? /^([A-Z]+-\d+)\s*:/.exec(msg) : null;
  return m ? `rule.${m[1]}` : null;
}
